/**
	FancyTable related function & actions
*/
// var chg;
// window.searchStr = "";

// var delay = (function(){
//   var timer = 0;
//   return function(callback, ms){
//     clearTimeout (timer);
//     timer = setTimeout(callback, ms);
//   };
// })();


// change table action description to the title of this button
$("body").on('click','.mobOptBtn',function(){
	if($(this).parent().find('.opt_hld:visible').length == 0){
		$('.tdata_options .opt_hld').hide();
		$(this).parent().find('.opt_hld').show();
	}else{
		$(this).parent().find('.opt_hld').hide();
	}
});


// change table action description to the title of this button
$("body").on('mouseover','.opt_hld a',function(e){
	e.preventDefault();
	
	var thisEl 		= $(this);
	var title 		= thisEl.attr('title');

	if(title){
		var orgEl 		= thisEl.parents('table').find(".options_hdr");
		var orgTitle 	= orgEl.html();
		orgEl.attr('data-org-title', orgTitle);
		orgEl.html(title).addClass("display");
	}
});

// return  table action description to default "Action"
$("body").on('mouseleave','.opt_hld a',function(e){
	e.preventDefault();
	
	var orgEl 		= $(this).parents('table').find(".options_hdr");
	var orgTitle 	= orgEl.attr('data-org-title');
	orgEl.html(orgTitle).removeClass("display");
});



// return  table action description to default "Action"
// $("body").on('change','#typeSel',function(){
// 	var val = $(this).val();
// 	var tscGroup = $(this).attr("tsc-group");

// 	if(val == "A"){
// 		$('.typeSelBox.' + tscGroup).show();
// 	}else{
// 		$('.typeSelBox.' + tscGroup).hide();
// 		$('.typeSelBox.' + tscGroup + '[rel="' + val + '"]').show();
// 	}
// });




	





// fancytable stuff
// cat table buttons: online, offline, trash etc.
// $('body').on('click', '.gridbox .data_tbl_cat_btn, .gridbox thead a', function(e){
// 	e.preventDefault();
	
// 	var href = window.dataUrl + "?search=" + window.searchStr + "&" + $(this).attr('href');
	
// 	axios.get(href)
// 		.then(function (response) {
// 			$('.gridbox.list .tableData').html(response.data['list']);
			
// 			// update raw dates to human readable form
// 			updateDateTime();
// 		})
// 		.catch(error => {
// 			console.log(error);
// 			if(error.response && (error.response.status === 401 || error.response.status === 419)){
// 				window.location.href = "/login";
// 			}
// 		});
// });



// $('body').on('click', '.gridbox .page_choice  a', function(e){
// 	e.preventDefault();
	
// 	var href = $(this).attr('href') + "&search=" + window.searchStr;
	
// 	axios.get(href)
// 		.then(function (response) {
// 			$('.gridbox.list .tableData').html(response.data['list']);
			
// 			// update raw dates to human readable form
// 			updateDateTime();
// 		})
// 		.catch(error => {
// 			console.log(error);
// 			if(error.response && (error.response.status === 401 || error.response.status === 419)){
// 				window.location.href = "/login";
// 			}
// 		});
// });



// on add a new item (app, device, project) button click
// $('body').on('click', '.chStateBtn', function(e){
// 	e.preventDefault();
	
// 	var href 		= $(this).attr('href');
// 	var returnUrl 	= $(this).attr('data-return');

// 	axios.get(href)
// 		.then(function (response) {
// 			if(returnUrl){
// 				window.location.href = returnUrl;
// 			}else{
// 				window.refreshPageData();
// 			}
// 		})
// 		.catch(error => {
// 			console.log(error);
// 			if(error.response && (error.response.status === 401 || error.response.status === 419)){
// 				window.location.href = "/login";
// 			}else{
// 				var cusalert = new window.cusAlert('Error', 'Could not change the status of this item.');
// 				cusalert.open();
// 			}
// 		});
// });		


// // on add a new item (app, device, project) button click
// $('body').on('click', '.destroyBtn', function(e){
// 	e.preventDefault();
	
// 	var thisEl 		= $(this);
// 	var href 		= thisEl.attr('href');
// 	var returnUrl 	= thisEl.attr('data-return');
	
// 	var delModal 	= new cusDialog("Delete", "Are you sure you want to permanently delete this item?", function(thisPopup){
// 		var formdata = new FormData();
// 		formdata.append('_method', 'DELETE');
		
// 		axios.post(href, formdata)
// 			.then(function (dashdata) {
// 				thisEl.parents('tr').remove();
// 				window.refreshPageData();
// 				delModal.closePopup();
// 			})
// 			.catch(error => {
// 				if(error.response && (error.response.status === 401 || error.response.status === 419)){
// 					window.location.href = "/login";
// 				}
// 			});
// 	});
// 	delModal.open();
// });


// $("body").on('keyup','.gridbox .searchbox',function(e){
// 	e.preventDefault();

// 	if(chg != ""){
// 		clearInterval(chg);
// 		$('#refbar').stop().width(0);
// 	}
	
// 	var thisEl	= $(this);
// 	window.searchStr	= thisEl.val();

	
// 	delay(function(){
// 		if(window.searchStr == ""){
// 			chg = setInterval(function(){window.dashRefresh(ctx)}, 15000);
// 		}
// 		$.ajax({
// 			type: "GET",
// 			url: dataUrl + "?orderby=title&order=ASC",
// 			data: {search : window.searchStr},
// 			success: function(dashdata) {
// 				//$("#content").html(data);
				
// 				$('.gridbox.list .tableData').html(dashdata['list']);
				
// 				$(".gridbox .searchbox").focus();
// 				$(".gridbox .searchbox").setCursorToTextEnd();
				
				
// 				// update dates to human readable
// 				updateDateTime();
// 			}
// 		});
		
// 	}, 800 );
// });
	
